// The AI permission (App Store 5.1.2(i)), asked once before personal data goes to an AI
// provider. The backend answers 428 `ai_consent_required` to anything AI the person starts
// without it; the api interceptor (services/api.js) asks through AiConsentDialog and
// repeats the request when the person agrees. Not native-only: the web asks the same way.
let pending = null;

export const AI_CONSENT_EVENT = 'aiConsentNeeded';

// Resolves true when the person agreed (and it was saved), false when they declined.
export function askAiConsent() {
  if (!pending) {
    pending = new Promise((resolve) => {
      window.dispatchEvent(new CustomEvent(AI_CONSENT_EVENT, { detail: { resolve } }));
    }).finally(() => { pending = null; });
  }
  return pending;
}
